export default __webpack_public_path__ + "2a639bc0d8f782167e6d646655f10220.jpg";